import { getVideoTag, putVideoTag } from '../../api/tags'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'

// const isDev = process.env.NODE_ENV === 'development'

const initialState = {
  loading: false,
  error: null,
  tags: null,
  videoTag: null,
}

export const getVideoTagReq = createAsyncThunk('getVideoTag', async (data, { rejectWithValue }) => {
  try {
    const res = await getVideoTag(data.id)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const putVideoTagReq = createAsyncThunk('putVideoTag', async (data, { rejectWithValue }) => {
  const { id, tags } = data
  try {
    const res = await putVideoTag(id, { tags })
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVideoTagReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(getVideoTagReq.fulfilled, (state, action) => {
        state.loading = false
        state.videoTag = action.payload
      })
      .addCase(getVideoTagReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(putVideoTagReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(putVideoTagReq.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(putVideoTagReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

// export const {} = tagsSlice.actions

export default tagsSlice.reducer
